import { render, staticRenderFns } from "./tempFooter.vue?vue&type=template&id=71a43614&scoped=true"
import script from "./tempFooter.vue?vue&type=script&lang=js"
export * from "./tempFooter.vue?vue&type=script&lang=js"
import style0 from "./tempFooter.vue?vue&type=style&index=0&id=71a43614&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a43614",
  null
  
)

export default component.exports